const LOCAL_STORAGE_DBG_PREFIX = `@gologin-dbg`;

export const DBG_FEATURE_OVERRIDES_KEY = LOCAL_STORAGE_DBG_PREFIX + ':feature-overrides';
